var map = {
	"./generate.js": "nFJB",
	"./python.js": "M0Cl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0Dd3";


//////////////////
// WEBPACK FOOTER
// ./src/utils/codeJson ^\.\/.*\.js$
// module id = 0Dd3
// module chunks = 3